import React from "react";
import { connect } from "react-redux";
import { EVT_KEYDOWN, KEY_S } from "../../../lib";
import { fontSizeBlack, fontSizeWhite } from "../../../images";
import {
    THEME_FONT_SIZE_SMALL,
    THEME_FONT_SIZE_MEDIUM,
    THEME_FONT_SIZE_LARGE,
} from "../../../reducers/reader";
import { setReaderFontSize } from "../../../reducers/reader/actions";
import { AppState } from "../../../store";

//@ts-ignore
const mapState = ({ reader }: AppState) => ({ fontSize: reader.get("size") });
const mapDispatch = {
    setReaderFontSize,
};
type StateProps = ReturnType<typeof mapState>;
type DispatchProps = typeof mapDispatch;

type Props = StateProps &
    DispatchProps & {
        isDark: boolean;
    };

class FontSize extends React.Component<Props> {
    componentDidMount() {
        window.addEventListener(EVT_KEYDOWN, this.onShortcut);
    }

    componentWillUnmount() {
        window.removeEventListener(EVT_KEYDOWN, this.onShortcut);
    }

    onShortcut = (evt: KeyboardEvent) => {
        if (evt.key.toUpperCase() === KEY_S) {
            this.onClick();
        }
    };

    onClick = () => {
        const { fontSize, setReaderFontSize } = this.props;

        if (fontSize === THEME_FONT_SIZE_SMALL) {
            setReaderFontSize(THEME_FONT_SIZE_MEDIUM);
        } else if (fontSize === THEME_FONT_SIZE_MEDIUM) {
            setReaderFontSize(THEME_FONT_SIZE_LARGE);
        } else if (fontSize === THEME_FONT_SIZE_LARGE) {
            setReaderFontSize(THEME_FONT_SIZE_SMALL);
        }
    };

    render() {
        const { isDark } = this.props;
        return (
            <img
                alt="حروف کا سائز"
                onClick={this.onClick}
                src={isDark ? fontSizeWhite : fontSizeBlack}
            />
        );
    }
}

export default connect(mapState, mapDispatch)(FontSize);
